
import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { StyleClassModule } from 'primeng/styleclass';

// Custom Services
import { ComponentAccess } from '../../../../../common/decorators/component-access.decorator';
import { CommonRoute } from '../../../../../common/enums/common-route.enum';
import { ToastLife } from '../../../../../common/enums/toast-life.enum';
import { AuthenticationService } from '../../../../../common/services/authentication/authentication.service';
import { MessageService } from 'primeng/api';
import { LayoutService } from '../../../../layout/service/app.layout.service';

@Component({
  standalone: true,
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  imports: [
    CardModule,
    ButtonModule,
    RouterModule,
    ProgressSpinnerModule,
    StyleClassModule
],
})
@ComponentAccess('VerifyEmailComponent')
export class VerifyEmailComponent implements OnInit {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  readonly layoutService = inject(LayoutService);
  private readonly messageService = inject(MessageService);

  readonly token = signal<string>('');
  readonly error = signal<Error | null>(null);
  readonly isLoading = signal<boolean>(true);

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const token = params.get('token') || '';
      this.token.set(token);
      if (!token) {
        this.isLoading.set(false);
      } else {
        this.verifyEmail();
      }
    });
  }

  verifyEmail() {
    const token = this.token();
    if (token) {
      this.isLoading.set(true);
      this.authenticationService.verifyEmail(token).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Email verified successfully',
            life: ToastLife.MEDIUM,
          });
          this.isLoading.set(false);
          this.navigateToLogin();
        },
        error: (error) => {
          this.isLoading.set(false);
          this.error.set(error);
        },
      });
    }
  }

  navigateToLogin(): void {
    this.router.navigate([CommonRoute.LOGIN]);
  }
}
